import { jwtDecode } from "jwt-decode";

const isTokenValid = (token: string): boolean => {
  try {
    // Декодируем токен
    const decoded: any = jwtDecode(token);
    // Текущее время в секундах
    const currentTime = Date.now() / 1000;

    // Проверяем наличие и актуальность поля exp
    if (decoded.exp && decoded.exp > currentTime) {
      return true; // Токен актуален
    } else {
      return false; // Токен истек
    }
  } catch (error) {
    console.error("Failed to decode token or invalid token", error);
    return false; // Токен некорректен
  }
};

export default isTokenValid;
